import { Pipe, PipeTransform } from '@angular/core';
import { AGENT_STATUS } from 'ag-common-lib/lib/lists/agent-status.enum';

@Pipe({ name: 'agentStatusBanIcon' })
export class AgentStatusBanIconPipe implements PipeTransform {
  transform(agentStatus: string): string {
    const cssClassName = {
      [AGENT_STATUS.DENIED]: 'danger',
    };
    return cssClassName[agentStatus] || 'normal';
  }
}
